var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex justify-center items-center flex-col select-none"},[_c('div',{staticClass:"main-icon flex justify-center items-center mb-6 mt-12 text-9xl"},[_c('img',{attrs:{"src":_vm.getImage(),"alt":"not found"}})]),_c('h1',{staticClass:"text-2xl mb-12 text-gray-500"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }